export const PRODUCT_TYPES = {
  CARD: { label: "Карт", color: "blue", enabled: true },
  LOAN: { label: "Зээл", color: "green", enabled: true },
  SAVINGS: { label: "Хадгаламж", color: "gold", enabled: true },
  INSURANCE: { label: "Даатгал", color: "red", enabled: true },
  APARTMENT: { label: "Орон сууцны зээл", color: "purple", enabled: true },
};

export const PRODUCT_TYPE_OPTIONS = Object.entries(PRODUCT_TYPES)
  .filter(([, v]) => v.enabled)
  .map(([key, v]) => ({ value: key, label: v.label }));

export const PRODUCT_TYPE_LABEL = (type) => PRODUCT_TYPES[type]?.label ?? type;
export const PRODUCT_TYPE_COLOR = (type) =>
  PRODUCT_TYPES[type]?.color ?? "default";
